import { createContext } from 'react';
import { PageFooter, PageHeader, SiteConfig } from '@bepro-travel/fe.shared';

export const MainContext = createContext({
  setHeader: (_header?: PageHeader) => {},
  header: undefined as PageHeader | undefined,
  setFooter: (_footer?: PageFooter) => {},
  setSiteConfig: (_siteConfig?: SiteConfig) => {},
});
